export default __webpack_public_path__ + "static/media/F0001.a0937fd1.png";